import {Component,OnInit,ViewChild} from '@angular/core';
import {FormulaireNdfService} from "@components/admin/parametre/formulaire/formulaire-ndf/formulaire-ndf.service";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {TranslateService} from "@ngx-translate/core";
import {NgForm} from "@angular/forms";
import {ParamNdf} from "@domain/admin/parametre/formulaire/param-ndf";

/**
 * Composant d'affichage de la page Formulaire Ndf
 *
 * @author Lionel Gimenez
 * @date 11/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-ndf'},
    selector: 'formulaire-ndf',
    templateUrl: './formulaire-ndf.component.html'
})
export class FormulaireNdfComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Options pour le mode de restitution du numéro de note de frais */
    modeRestitutionNumeroOptions: Array<{ value: number,libelle: string }>;

    /** Options pour le mode de restitution du numéro de justificatif */
    modeRestitutionJustificatifOptions: Array<{ value: number,libelle: string }>;

    /** Options pour le contrôle des dépenses */
    controleOptions: Array<{ value: number,libelle: string }>;

    /** Formulaire */
    @ViewChild('form') form: NgForm;

    /**
     * Constructeur
     */
    constructor(
        public formulaireNdfService: FormulaireNdfService,
        private translateService: TranslateService,
    ) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Initialisation des listes d'options
        this.initOptionsListes();

        //Chargement des données
        this.formulaireNdfService.load();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            isDisabled: () => !this.form?.valid,
            doAction: () => this.formulaireNdfService.save(),
        }]);
    }

    /**
     * Initialise les listes d'options pour les sélecteurs
     */
    private initOptionsListes(): void {
        //Options pour le mode de restitution du numéro de note de frais
        this.modeRestitutionNumeroOptions = [
            {
                value: 0,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.numeroNoteDeFraisPost.sequentielCollaborateur")
            },
            {
                value: 1,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.numeroNoteDeFraisPost.sequentielCollaborateurNumerotation")
            }
        ];

        //Options pour le mode de restitution du numéro de justificatif
        this.modeRestitutionJustificatifOptions = [
            {
                value: 0,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.numeroJustificatifPost.sequentielJustificatif")
            },
            {
                value: 1,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.numeroJustificatifPost.noteSequentiel")
            }
        ];

        //Options pour le contrôle des dépenses
        this.controleOptions = [
            {
                value: 0,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.controleOption.nonControle")
            },
            {
                value: 1,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.controleOption.nonBloquant")
            },
            {
                value: 2,
                libelle: this.translateService.instant("admin.parametres.formulaire.ndf.controleOption.bloquant")
            }
        ];
    }

    /**
     * Gestion de la modification de l'affichage de l'imputation budgétaire
     */
    onMIBChange(paramNdf: ParamNdf) {
        //Si l'affichage de l'imputation budgétaire est activé
        if (!paramNdf.affichageMIB) {
            //On desactive l'affichage du mois par defaut
            paramNdf.noMIBDefaut = false;
        }
    }
}